import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Download, Home, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Success() {
  return <div className="min-h-screen bg-[#f4f4f4] flex items-center justify-center p-4" data-id="element-635">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="bg-white max-w-lg w-full rounded-2xl shadow-xl p-8 text-center" data-id="element-636">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-637">
          <CheckCircle className="w-10 h-10 text-green-600" data-id="element-638" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-639">
          ¡Pedido Confirmado!
        </h1>
        <p className="text-gray-500 mb-8" data-id="element-640">
          Gracias por tu compra. Hemos enviado los detalles y enlaces de
          descarga a tu correo electrónico.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-8 text-left" data-id="element-641">
          <p className="text-sm text-gray-500 mb-1" data-id="element-642">Número de Pedido</p>
          <p className="font-mono font-bold text-gray-900 text-lg" data-id="element-643">
            #ORD-2024-8392
          </p>
        </div>

        <div className="space-y-3" data-id="element-644">
          <button className="w-full py-3 bg-[#234d99] text-white font-bold rounded-lg hover:bg-[#1a3a75] transition-colors flex items-center justify-center gap-2" data-id="element-645">
            <Download className="w-5 h-5" data-id="element-646" />
            Ir a mis descargas
          </button>
          <Link to="/" className="w-full py-3 bg-white border border-gray-300 text-gray-700 font-bold rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2" data-id="element-647">
            <Home className="w-5 h-5" data-id="element-648" />
            Volver al inicio
          </Link>
        </div>
      </motion.div>
    </div>;
}